// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-transfer .el-transfer .el-transfer-panel{flex:1}.customer-transfer .el-transfer .el-transfer-panel .el-transfer-panel__list .el-checkbox__label>div span{display:inline-block}.customer-transfer .el-transfer .el-transfer-panel .el-transfer-panel__list .el-checkbox__label>div span:first-child{width:6.25rem;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
